<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    :maskClosable="false"
    class="form-questionnair-dialog"
    @cancel="handleCancel"
  >
    <div class="form-questionnair-container">
      <iframe
        id="formQuestionnair"
        webkitallowfullscreen=""
        mozallowfullscreen=""
        allowfullscreen=""
        :src="formUrlMap[gameId]"
        width="100%"
        height="100%"
      ></iframe>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "FormQuestionnaireDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    gameId: {
      type: Number,
    },
  },
  data() {
    return {
      // 13023 MyGamez 国内站 "帝国与谜题"
      // 11909 上海栖亘 国际站 "HAZEREVERB"
      // 13913 ican 艾肯遊戲客服
      formUrlMap: {
        2664: "https://local.aihelp.net/form/#/?unionId=6d00d4291a2b4eba9f631806942fe25f&ep=6962780c8a259bf2f0f00c5c26db1b8d0952f1a744ad20f15952ea5bf275efa5b09e3aab58457921959d2c0820930096bf9b6fb54acf4ee88d50c34a5563029d8fe50d9e481d0c48df973904159a8e2143b4eed8d4a8dc4a74bd9f22c5d88a0941088d08bb65fa00&isH5=1",
        13023: "https://aihelpcn.net/form/#?unionId=1f9ce76e692f4ebfb3ef2acd31b17dbd&ep=6962780c8a259bf2f0f00c5c26db1b8d0952f1a744ad20f15952ea5bf275efa525be8375fba8e8ff551a515ca98bccc87338b427fbe392735bdb3f2c7f8a7783c1aa2af116bc33e587e3bb3d750fa3b857c6d680330fe05b8996273a8257c1d6804874b3a557ff1e&isH5=1",
        11909: "https://aihelp.net/form/#?unionId=baf40d3c68cb4a7abb6390f5762fcf7d&ep=6962780c8a259bf2f0f00c5c26db1b8d0952f1a744ad20f15952ea5bf275efa51092f05a3f9783639dba7b4e0b5f4bcb29410225dc00e6607b4095039c2db08614ae6a1f46ced617f7b59084a001d043f1aec5cb3336e3774405138d53950014655dfd3d16039000&isH5=1",
        13913: "https://aihelp.net/form/#/?unionId=342a9963c87f49afb9fdd3f3dc03e061&ep=6962780c8a259bf2f0f00c5c26db1b8d0952f1a744ad20f15952ea5bf275efa5b585953745a06f5977a5c40eb2e6ccff0dc479d3e8df2227b785419301718210c59ec76c990fbdbe1a97c9ac9ec11ce4fa8afb48d3d504accdaadec0b64a0245d720c117ef6ee9ba&isH5=1",
      },
    };
  },
  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-questionnair-dialog {
  /deep/ .ant-modal {
    width: 600px !important;
    border-radius: 4px;
    overflow: hidden;
    background-color: rgb(241, 242, 243);
    padding: 0;
  }
  /deep/ .ant-modal-content {
    height: 80vh;
    .ant-modal-body {
      height: 100%;
      padding: 0px;
    }
    .ant-modal-close {
      width: 100%;
      height: 40px;
      background-color: rgb(241, 242, 243);
      .ant-modal-close-x {
        float: right;
        width: 40px;
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .form-questionnair-container {
    height: 100%;
    iframe {
      border: 0;
    }
  }
}
</style>
